<template>
  <div class="p-9 region-notice">
    <Loader v-if="isLoading" />

    <bim-text type=main bold class="mb-6">Расскажите нам, где вы работаете?</bim-text>

    <bim-text type=medium>Если вы укажете сферу деятельности и компанию, мы сможем оптимизировать для вас показы моделей</bim-text>

    <bim-input
      placeholder="Компания"
      v-model="form.companyName"
      class="mt-6"
    />

    <bim-select
      class="mt-6"
      placeholder="Сфера деятельности"
      :options="listRoles"
      v-model="form.role"
      listPosition=top
      width=100%
      :formModel="_self"
      formKey="form.role"
    />

    <bim-select
      class="mt-6"
      placeholder="Специализация"
      :options="listSpecialisations"
      v-model="form.specialisation"
      :disabled="form.role !== 'designer'"
      listPosition=top
      width=100%
    />

    <div class="mt-6 toast__button-wrapper">
      <bim-button
        label="Отмена"
        @click="onAnswerNegative"
        class="mr-9 toast__button"
        color=gray
      />

      <bim-button
        class="toast__button"
        label="Отправить"
        @click="onAnswerPositive"
      />
    </div>
  </div>
</template>

<script>
import bimInput from '@/components/form/bimInput/bimInput.vue'
import bimButton from '@/components/form/bimButton/bimButton.vue'
import bimSelect from '@/components/form/bimSelect/bimSelect.vue'
import bimText from '@/components/text/bimText/bimText.vue'

import Loader from '@/components/core/loader'

export default {
  name: 'NoticeRegion',
  components: {
    bimInput,
    bimButton,
    bimSelect,
    bimText,
    Loader
  },
  props: {
    user: Object
  },
  data () {
    return {
      isLoading: false,
      form: {
        role: '',
        specialisation: '',
        companyName: '',
        ...(this.user.context || {})
      }
    }
  },
  watch: {
    'form.role' (role) {
      if (role !== 'designer') {
        this.form.specialisation = ''
      }
    }
  },
  mounted () {
    if (this.form.role !== 'designer') {
      this.form.specialisation = ''
    }
  },
  methods: {
    onAnswerNegative () {
      this.emitCancel()
    },

    onAnswerPositive () {
      if (!this.$v2.forceValidateForm()) return
      this.emitSave(this.form)
    },

    emitSave (payload) {
      this.isLoading = true
      this.$emit('save', {
        type: 'context',
        payload,
        onFinish: () => {
          this.isLoading = false
        }
      })
    },

    emitCancel () {
      this.$emit('close')
    }
  },
  computed: {
    listSpecialisations () {
      return this.$bimTranslate('signUp.specialisations', 'ru')
        .map(label => ({
          label,
          value: label
        }))
    },
    listRoles () {
      return Object
        .entries(this.$bimTranslate('signUp.roles', 'ru'))
        .map(([value, label]) => ({ value, label }))
    },
    formValidation () {
      return {
        'form.role': ['required']
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.region-notice {

  .toast__button-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .toast__button {
    flex-grow: 1;
    padding-left: 0;
    padding-right: 0;
  }

  .region-notice__save-button {
    display: block;
    margin-left: auto;
  }
}
</style>
